/**
 * OKX timeframe configuration and interval mapping.
 * @see https://www.okx.com/docs-v5/en/#order-book-trading-market-data-get-candlesticks
 */

import {
  registerExchangeTimeframes,
  resolutionToSeconds,
  type TimeframeConfig,
} from '../../lib/timeframes';

/**
 * OKX supports wide range of intervals.
 */
export const OKX_TIMEFRAMES: TimeframeConfig = {
  native: [
    '1m',
    '3m',
    '5m',
    '15m',
    '30m',
    '1H',
    '2H',
    '4H',
    '6H',
    '12H',
    '1D',
    '1W',
    '1M',
    '3M',
    '6M',
    '1Y',
  ],
  synthetic: ['1s'], // Use ticker for 1s
  minIntervalSeconds: 60,
};

// Register with central registry
registerExchangeTimeframes('okx', OKX_TIMEFRAMES);

/**
 * Maps TradingView resolution to OKX interval format.
 */
export const mapToOkxInterval = (resolution: string): string => {
  const seconds = resolutionToSeconds(resolution);

  if (seconds < 60) return '1m';
  if (seconds === 60) return '1m';
  if (seconds === 180) return '3m';
  if (seconds === 300) return '5m';
  if (seconds === 900) return '15m';
  if (seconds === 1800) return '30m';
  if (seconds === 3600) return '1H';
  if (seconds === 7200) return '2H';
  if (seconds === 14400) return '4H';
  if (seconds === 21600) return '6H';
  if (seconds === 43200) return '12H';
  if (seconds === 86400) return '1D';
  if (seconds === 604800) return '1W';
  if (seconds === 2592000) return '1M'; // 30 days
  if (seconds === 7776000) return '3M'; // 90 days
  if (seconds === 15552000) return '6M'; // 180 days
  if (seconds === 31536000) return '1Y'; // 365 days

  // Default to closest
  if (seconds < 180) return '1m';
  if (seconds < 300) return '3m';
  if (seconds < 900) return '5m';
  if (seconds < 1800) return '15m';
  if (seconds < 3600) return '30m';
  if (seconds < 7200) return '1H';
  if (seconds < 14400) return '2H';
  if (seconds < 21600) return '4H';
  if (seconds < 43200) return '6H';
  if (seconds < 86400) return '12H';
  if (seconds < 604800) return '1D';
  if (seconds < 2592000) return '1W';
  if (seconds < 7776000) return '1M';
  if (seconds < 15552000) return '3M';
  if (seconds < 31536000) return '6M';

  return '1Y';
};
